import { LoaderFunctionArgs } from "react-router-dom";
import { networkCall } from "../../../../../utils/network-call/network-call";

export const CompanyAdminUserEditLoader = async (args: LoaderFunctionArgs) => {
    const getUserResponse = await networkCall(`/users/${ args.params.id }`);
    return { getUserResponse };
};